(
    function (skyward, $)
    {
        "use strict";

        skyward.accountDimensionEEL = skyward.accountDimensionEEL || {};
        skyward.accountDimensionEEL.popupModalLayer = null;
        skyward.accountDimensionEEL.popupModalLayerOpen = false;

        const requestHandler = skyward.extensions.getSingleRequestHandler();

        const idGenerator = skyward.extensions.getIdGenerator("popup", "_accountDimensionEELBrowse");

        var controlsTypeChangedCallback;
        var beforeKeyDownCallback;
        var afterKeyDownCallback;
        var beforeKeyUpCallback;
        var afterKeyUpCallback;

        skyward.accountDimensionEEL.setControlsTypeChangedCallback = function (callback)
        {
            controlsTypeChangedCallback = callback;
        };

        skyward.accountDimensionEEL.setBeforeKeyDownCallback = function (callback)
        {
            beforeKeyDownCallback = callback;
        };

        skyward.accountDimensionEEL.setAfterKeyDownCallback = function (callback)
        {
            afterKeyDownCallback = callback;
        };

        skyward.accountDimensionEEL.setBeforeKeyUpCallback = function (callback)
        {
            beforeKeyUpCallback = callback;
        };

        skyward.accountDimensionEEL.setAfterKeyUpCallback = function (callback)
        {
            afterKeyUpCallback = callback;
        };

        var init = function (selector)
        {
            $(selector + " .accountDimensionEEL").each(function ()
            {
                var accountDimensionEEL = $(this);
                var accountDimensionEELCode = accountDimensionEEL.find(".accountDimensionEELCode");
                var accountDimensionEELCodeButton = accountDimensionEEL.find(".accountDimensionEELCodeButton");
                var accountDimensionEELDescription = accountDimensionEEL.find(".accountDimensionEELDescription");
                var accountDimensionEELValue = accountDimensionEEL.find(".accountDimensionEELValue"); //hidden id
                var accountDimensionEELCodeValue = accountDimensionEEL.find(".accountDimensionEELCodeValue"); //hidden code value
                var accountDimensionEELDescriptionValue = accountDimensionEEL.find(".accountDimensionEELDescriptionValue"); //hidden description value
                var accountDimensionEELpostData = accountDimensionEEL.data("postdata");
                var accountDimensionEELhidePrimaryBrowseButton = accountDimensionEEL.data("hideprimarybrowsebutton");
                let selectedValue = null;

                const label = accountDimensionEEL.findLabel();
                if (label.length)
                {
                    const labelText = label.text().replace(/\*/g, "");
                    accountDimensionEELCode.attr("aria-label", labelText + " Dimension Code");
                    accountDimensionEELDescription.attr("aria-label", labelText + " Dimension Description");
                    // The forID of accountDimensionEEL points to the container.
                    // Assign the forID to the first textbox in the container for valid accessibility. 
                    const firstInputId = (accountDimensionEELCode.length ? accountDimensionEELCode : accountDimensionEELDescription).attr("id");
                    if (firstInputId)
                    {
                        label.attr("for", firstInputId);
                    }
                }

                //Selector filter
                var filter = accountDimensionEEL.data("filter");

                //get the hidden values
                var accountDimensionEELValueData = accountDimensionEELValue.data();

                var popupModalLayer = null;
                
                skyward.eel.setFocusToTextBoxOnClick(accountDimensionEEL);

                var getBrowsePostData = function (textBox)
                {
                    var postData = {};
                    postData.filter = JSON.stringify(filter);

                    if (!textBox.data("dynamicfiltervalue"))
                    {
                        return $.extend({}, accountDimensionEELpostData, postData);
                    }

                    var objSelector;
                    var wrapperId = accountDimensionEEL.attr("id");
                    var filterPostData = {};

                    if (wrapperId.indexOf("_") > -1)
                    {
                        objSelector = wrapperId.split('_')[0] + "_";
                    }
                    else
                    {
                        objSelector = "";
                    }

                    var dependentFields = textBox.data("dynamicfilterfield").split(',');
                    var dependentValues = textBox.data("dynamicfiltervalue").split(',');

                    for (var i = 0; i < dependentFields.length; i++)
                    {
                        filterPostData[dependentFields[i]] = skyward.controls.getValue($('[id^="' + objSelector + dependentValues[i] + '"]'));
                    }

                    var dependentBrowsePostData = {};
                    for (var key in accountDimensionEELpostData)
                    {
                        var fieldName = key.substring(key.lastIndexOf('.') + 1);

                        if (filterPostData[fieldName] && filterPostData[fieldName] != accountDimensionEELpostData[key])
                        {
                            dependentBrowsePostData[key] = filterPostData[fieldName];
                        }
                        else
                        {
                            dependentBrowsePostData[key] = accountDimensionEELpostData[key];
                        }
                    }

                    return $.extend({}, dependentBrowsePostData, filterPostData, postData);
                };

                var addToBrowseList = function (browseId, textbox)
                {
                    skyward.browse.browseList[browseId] =
                    {
                        id: browseId,
                        pageModule: accountDimensionEELValueData.area,
                        pageObject: accountDimensionEELValueData.controller,
                        pageScreen: textbox.data("action"),
                        browseType: "Default",
                        browseModule: accountDimensionEELValueData.area,
                        browseObject: accountDimensionEELValueData.controller,
                        dataModule: accountDimensionEELValueData.area, //TODO: PR 4339258 update to use actual dataModule instead of area
                        dataObject: accountDimensionEELValueData.controller, //TODO: PR 4339258 update to use actual dataObject instead of controller
                        browseName: "AccountDimensionBrowse",
                        selectMode: true,                        
                        codeEelName: accountDimensionEELValue.attr("name"),
                        codeEelDescription: accountDimensionEELDescription.attr("id"),
                        hidePrimaryBrowseButton: accountDimensionEELhidePrimaryBrowseButton,
                        routeHash: accountDimensionEELValueData.routeHash,
                        refreshTimeout: -1,
                        data: getBrowsePostData(textbox),
                        keyEventsEnabled: true,
                        renderViewButton: false,
                        disableBrowseSort: true,
                        hideOptionsButton: true,
                        preventColumnResize: true,
                        queryParameterData: accountDimensionEEL.codeEELQueryParameterData
                    };
                    skyward.browse.openBrowses.push(browseId);
                };

                var createModalLayer = function (browseId, textbox)
                {
                    const textBoxId = textbox.attr("id");
                    const popupContent = $("<div>", { "class": "popup", id: textBoxId + "_popup" });
                    popupContent.append($("<div>", { id: browseId, "class": "browse" }));

                    skyward.browse.eventCallbacks.recordSelectionMade.registerCallback(selectionMadeHandler);

                    const beforeClose = function ()
                    {
                        textbox.attr("aria-expanded", "false");

                        if (selectedValue == null)
                        {
                            accountDimensionEELValue.val(null);
                            accountDimensionEELValue.change();
                        }
                        else if (selectedValue != accountDimensionEELValue.val())
                        {
                            accountDimensionEELValue.val(selectedValue);
                            accountDimensionEELValue.change();
                        }

                        skyward.browse.eventCallbacks.recordSelectionMade.deregisterCallback(selectionMadeHandler);

                        updateBoxes();
                        popupModalLayer = null;
                        requestHandler.closeOpenRequest();
                        skyward.accountDimensionEEL.popupModalLayer = null;
                        skyward.accountDimensionEEL.popupModalLayerOpen = false;
                        skyward.browse.openBrowses.splice(skyward.browse.openBrowses.indexOf(browseId), 1);
                    };

                    return skyward.modalLayer.showCodeEELDialog(popupContent, textbox, textbox.closest(".js-showEELContainer"), beforeClose, accountDimensionEELValueData);

                    function selectionMadeHandler(eventData)
                    {
                        if (eventData.browseId === browseId)
                        {
                            selectedValue = eventData.selectedId;
                        }
                    }
                };

                var showPopup = skyward.debounce(function (textBox)
                {
                    textBox.attr("aria-expanded", "true");
                    if (skyward.accountDimensionEEL.popupModalLayer == null)
                    {
                        const browseId = idGenerator.getNewId();
                        addToBrowseList(browseId, textBox);
                        popupModalLayer = createModalLayer(browseId, textBox);
                        selectedValue = accountDimensionEELValue.val();
                        skyward.accountDimensionEEL.popupModalLayer = popupModalLayer;
                        skyward.accountDimensionEEL.popupModalLayerOpen = true;
                    }
                }, 100);

                var doSearch = skyward.debounce(function (searchText)
                {
                    const browse = skyward.browse.getInnerBrowse(accountDimensionEELValueData.layer.container);
                    if (browse === undefined)
                    {
                        return;
                    }
                    requestHandler.request = skyward.browse.performCodeEELSearch(browse.id, { codeEELSearchText: searchText, codeEelName: accountDimensionEELCodeValue.attr("id"), seekId: accountDimensionEELValue.val() });
                }, 100);

                var toggleCodePopup = function ()
                {
                    if (!accountDimensionEELCode.attr("readonly"))
                    {
                        if (popupModalLayer == null)
                        {
                            showPopup(accountDimensionEELCode);
                            doSearch();
                        }
                        else
                        {
                            popupModalLayer.close();
                        }
                    }
                };

                var keydown = function (event)
                {
                    if (!skyward.keys.keyIsNumberOrLetter(event.shiftKey, event.which))
                    {
                        if (event.which == 27)
                        {
                            if (popupModalLayer != null && popupModalLayer.onscreen)
                            {
                                popupModalLayer.close();
                            }
                            else
                            {
                                skyward.window.closePopup();
                            }
                        }
                        else if (Array(8, 9, 13, 16, 27, 37, 38, 40, 116, 123).indexOf(event.which) == -1)
                        {
                            event.preventDefault();
                        }
                    }

                    //before callbacks
                    if (typeof beforeKeyDownCallback === 'function')
                    {
                        beforeKeyDownCallback(event);
                        if (event.isDefaultPrevented())
                        {
                            return;
                        }
                    }

                    var sender = $(this);
                    var textBoxId = sender.attr("id");
                    var codeValue = sender.val();
                    var codeMaxLength = $("#" + textBoxId).attr('maxlength');

                    if (event.which == 9) //Tab
                    {
                        if (popupModalLayer && popupModalLayer.onscreen)
                        {
                            popupModalLayer.close();
                        }

                        accountDimensionEELCodeValue.val(codeValue);
                        accountDimensionEELCode.val(codeValue);
                    }
                    else if (event.shiftKey && event.which == 9)
                    {
                        if (popupModalLayer && popupModalLayer.onscreen)
                        {
                            popupModalLayer.close();
                        }
                    }
                    else if (event.which == 13) //enter
                    {
                        if (popupModalLayer == null && skyward.accountDimensionEEL.popupModalLayer == null)
                        {
                            if (codeValue.length != codeMaxLength)
                            {
                                codeValue = codeValue.padRight(codeMaxLength, '0');
                            }

                            accountDimensionEELCode.val(codeValue);
                            accountDimensionEELCodeValue.val(codeValue);
                            skyward.accountDimensionEEL.setDescription(sender, false);
                            skyward.tabbing.focusAfter(sender);
                            skyward.accountLookupForm.checkForSingleAccount(sender);
                        }
                    }

                    //after callbacks
                    if (typeof afterKeyDownCallback === 'function')
                    {
                        afterKeyDownCallback(event);
                        if (event.isDefaultPrevented())
                        {
                            return;
                        }
                    }
                };

                var keyup = function (event)
                {                   
                    if (typeof beforeKeyUpCallback === 'function')
                    {
                        beforeKeyUpCallback(event);
                        if (event.isDefaultPrevented())
                        {
                            return;
                        }
                    }

                    var sender = $(this);
                    var textBoxId = sender.attr("id");
                    var codeValue = sender.val();
                    if (codeValue != null)
                    {
                        codeValue = codeValue.toString().toUpperCase();
                        sender.val(codeValue);
                    }
                    var codeMaxLength = $("#" + textBoxId).attr('maxlength');

                    if (skyward.accountDimensionEEL.popupModalLayer != null && (popupModalLayer == null || !popupModalLayer.onscreen))
                    {
                        return;
                    }

                    var shiftTab = false;
                    if (event.which == 16 || event.which == 9 || event.shiftKey)
                    {
                        shiftTab = true;
                    }

                    //set description when entered text is at the max length for this dimensions
                    if ((popupModalLayer == null || (popupModalLayer && !popupModalLayer.onscreen)) && codeValue.length == codeMaxLength && event.which != 8 && event.which != 39 && event.which != 40)//8 = backspace, 39 = right arrow, 40 = down arrow
                    {
                        //set the hidden code value
                        sender.siblings('.accountDimensionEELCodeValue').val(codeValue);
                        skyward.accountDimensionEEL.setDescription(sender, shiftTab);

                        // Don't run if shift tab is pressed or the enter key is pressed.
                        if (!shiftTab && event.which != 13)
                        {
                            skyward.tabbing.focusAfter(sender);
                        }
                    }

                    //clear the current textbox's hidden id/value and description
                    if (codeValue.length == 0)
                    {
                        skyward.accountDimensionEEL.clear(sender.parent());
                    }

                    if (popupModalLayer == null && (event.which == 39 || event.which == 40) && codeValue.length <= codeMaxLength)//39 = right arrow, 40 = down arrow
                    {
                        showPopup(sender);
                        if (codeValue.length == codeMaxLength)
                        {
                            doSearch();
                        }
                        else
                        {
                            doSearch(codeValue);
                        }
                    }
                    else if (popupModalLayer && popupModalLayer.onscreen)
                    {
                        if (Array(27, 40, 38, 13, 9, 16).indexOf(event.which) == -1)
                        {
                            doSearch(codeValue);
                        }
                    }

                    if ((popupModalLayer == null || (popupModalLayer && !popupModalLayer.onscreen)) && codeValue.length == codeMaxLength)
                    {
                        //do nothing
                    }
                    else if (codeValue.length == codeMaxLength && !(event.which == 16 || event.shiftKey || event.which == 9 || event.which == 39 || event.which == 40))
                    {
                        skyward.accountDimensionEEL.setDescription(sender, false, true);
                        if (popupModalLayer != null)
                        {
                            popupModalLayer.close();
                        }
                        updateBoxes();
                    }
                    
                    if (typeof afterKeyUpCallback === 'function')
                    {
                        afterKeyUpCallback(event);
                        if (event.isDefaultPrevented())
                        {
                            return;
                        }
                    }
                };

                var updateBoxes = function ()
                {
                    if (accountDimensionEELValue.val())
                    {
                        var postData = { "securityHash": accountDimensionEELValueData.securityHash };
                        $.ajax({
                            url: skyward.global.virtualDir + "Account/Dimension/AccountDimensionEEL/" + accountDimensionEELValue.val(),
                            type: "POST",
                            dataType: "JSON",
                            data: postData,
                            success: function (data)
                            {
                                var description = (data != null && data.description != null) ? data.description : '';

                                accountDimensionEELCode.val(data.code);
                                skyward.accountLookupForm.checkForSingleAccount(accountDimensionEELCode);
                                accountDimensionEELCodeValue.val(data.code);
                                accountDimensionEELDescription.val(description).text(description);
                                accountDimensionEELDescriptionValue.val(description);

                                var dependents = accountDimensionEELCode.data('dependents');

                                if (dependents)
                                {
                                    updateDependents(dependents);
                                }

                                if (accountDimensionEELCode.hasClass('ControlsType') && typeof controlsTypeChangedCallback === 'function')
                                {
                                    controlsTypeChangedCallback(accountDimensionEELCode, true);
                                }
                                //only try moving focus if the screen with the eels is not closing (closing makes the eels not tabbable)
                                else if (accountDimensionEELCode.is(':tabbable'))
                                {
                                    skyward.tabbing.focusAfter(accountDimensionEELCode);
                                }
                            }
                        });
                    }
                };

                var updateDependents = function (dependents)
                {
                    $.each(dependents.dependents, function (k, v)
                    {
                        var dependentCode = $('#' + v.Id).children('.accountDimensionEELCode');
                        if (dependentCode.length > 0)
                        {
                            var maxLength = dependentCode.attr('maxlength');
                            var codeLength = dependentCode.val().length;

                            if (codeLength == maxLength)
                            {
                                skyward.accountDimensionEEL.setDescription(dependentCode, false);
                            }
                        }
                    });
                };

                //public methods
                skyward.accountDimensionEEL.setDescription = function (sender, preventFocusChange, forceValueChangeEvent)
                {
                    var code = $(sender);
                    var codeValue = code.val();
                    var dimensionGroupId = code.parent().siblings('.accountDimensionEELDimensionGroup').val();
                    var fundId = $('.IsFund').parent().siblings('.accountDimensionEELValue').val();
                    var isFund = code.hasClass('IsFund');
                    var parentDimensionID = null;
                    var isWorkflow = $('input[name=IsOnWorkflow]').val() == 'true'; // This is a string coming from a hidden field

                    //parent dimension info
                    var parentDimensionName = code.data("parentname");
                    if (parentDimensionName)
                    {
                        var parentDimension = $('#' + parentDimensionName + '_hiddenid');
                        if (parentDimension.length > 0)
                        {
                            parentDimensionID = parentDimension.val();
                            parentDimensionID = (parentDimensionID != '') ? parentDimensionID : 0;
                        }
                    }
                    //child dimension info
                    var childDimensionName = accountDimensionEEL.prop("id") + "ChildDimension";

                    if (sender.hasClass('ControlsType') && typeof controlsTypeChangedCallback === 'function')
                    {
                        controlsTypeChangedCallback(sender, preventFocusChange);
                    }

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Account/Dimension/AccountDimensionEELDescriptionLookup",
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                code: codeValue,
                                dimensionGroupId: dimensionGroupId,
                                fundId: fundId,
                                isFund: isFund,
                                parentDimensionID: parentDimensionID
                            },
                            success: function (data)
                            {
                                var codeContainer = code.parent();
                                var hiddenCode = codeContainer.siblings('.accountDimensionEELCodeValue');
                                var description = codeContainer.siblings('.accountDimensionEELDescription');
                                var hiddenDescription = codeContainer.siblings('.accountDimensionEELDescriptionValue');
                                var hiddenDimensionIDCopiedFrom = codeContainer.siblings('.accountDimensionEELDimensionIDCopiedFromValue');
                                var dimensionEELValue = codeContainer.siblings('.accountDimensionEELValue');

                                var dimensionValueOld = dimensionEELValue.val();
                                var dimensionValueNew = data != null ? data.DimensionId : '';

                                hiddenCode.val(code.val());
                                hiddenDimensionIDCopiedFrom.val((data != null && data.DimensionIDCopiedFrom != null) ? data.DimensionIDCopiedFrom : '');
                                description.val((data != null && data.Description != null) ? data.Description : '');
                                hiddenDescription.val(description.text());

                                var dependents = code.parent().data('dependents');

                                if (dimensionValueOld != dimensionValueNew)
                                {
                                    dimensionEELValue.val(dimensionValueNew);

                                    if (dependents)
                                    {
                                        updateDependents(dependents);
                                    }
                                }

                                if (forceValueChangeEvent)
                                {
                                    dimensionEELValue.change();
                                }

                                skyward.ajax.getAllInputElements(".workflowContent").then(postData =>
                                {
                                    var container = skyward.window.getClosestContentPanel(code);

                                    if (isWorkflow)
                                    {
                                        sendAjaxWorkflow(null, dimensionEELValue.prop("name"), postData, "Account/Dimension/SetSummaryDefaultsWorkflow", container);
                                    }
                                    else if (isFund)
                                    {
                                        sendAjaxWorkflow(null, dimensionEELValue.prop("name"), postData, "Account/Dimension/VerifyAndUpdateFundDependentDimensions", container);
                                    }

                                    if (code.siblings(childDimensionName))
                                    {
                                        sendAjaxWorkflow(null, dimensionEELValue.prop("name"), postData, "Account/Account/VerifyAndUpdateParentChildDimensions", container);
                                    }
                                });
                            }
                        }
                    );
                };

                var sendAjaxWorkflow = function (event, targetName, postData, ajaxPath, container)
                {
                    if (!event) {
                        postData._controlAjaxFiredFrom = targetName
                    }
                    else {
                        postData._controlAjaxFiredFrom = event.target.name;
                    }
                    $.ajax({
                        url: skyward.global.virtualDir + ajaxPath,
                        type: "POST",
                        dataType: "JSON",
                        data: postData,
                        success: function (data)
                        {
                            skyward.ajax.handleResponse(data, "", false, container);
                        }
                    });
                };

                skyward.accountDimensionEEL.accountReloadPrefillValues = function (displayAccount)
                {
                    skyward.accountlookupeel.makeReadOnly();
                    var accountParts = displayAccount.split(" ");
                    $('.accountDimensionEELCode').each(function (i, o)
                    {
                        var codeField = $(o);
                        if (codeField.parent().siblings('.dimensionPosition').val() == 1)
                        {
                            codeField.val(accountParts[0]);
                        }
                        else
                        {
                            codeField.val(accountParts[codeField.parent().siblings('.dimensionPosition').val()]);
                        }
                    });

                    $('.accountDimensionEELCodeValue').each(function (i, o)
                    {
                        var hiddenCode = $(o);
                        if (hiddenCode.parent().siblings('.dimensionPosition').val() == 1)
                        {
                            hiddenCode.val(accountParts[0]);
                        }
                        else
                        {
                            hiddenCode.val(accountParts[hiddenCode.parent().siblings('.dimensionPosition').val()]);
                        }
                    });
                };

                //This function clears all but the non-fund and non-controls type dimensions
                skyward.accountDimensionEEL.clearValues = function ()
                {
                    $('.accountDimensionEEL').children('.IsFund, .ControlsType').each(function ()
                    {
                        skyward.accountDimensionEEL.clear($(this).parent());
                    });
                };

                //This function clears all values, no matter the type of dimension
                skyward.accountDimensionEEL.clearAllValues = function ()
                {
                    $('.accountDimensionEEL').each(function ()
                    {
                        skyward.accountDimensionEEL.clear(this);
                    });
                };

                skyward.accountDimensionEEL.clear = function (dimensionEEL)
                {
                    dimensionEEL = dimensionEEL instanceof jQuery ? dimensionEEL : $(dimensionEEL);

                    dimensionEEL.children('.accountDimensionEELValue').val('');
                    dimensionEEL.children('.accountDimensionEELCode').text('').val('');
                    dimensionEEL.children('.accountDimensionEELCodeValue').val('');
                    dimensionEEL.children('.accountDimensionEELDescription').text('').val('');
                    dimensionEEL.children('.accountDimensionEELDescriptionValue').val('');
                };

                skyward.accountDimensionEEL.getDimensionData = function ()
                {
                    var data = [];

                    $.each($('.accountDimensionEELCode'), function (i, o)
                    {
                        var obj = $(o);
                        data.push({ value: obj.val(), position: obj.parent().siblings('.dimensionPosition').val(), maxlength: obj.attr('maxlength'), isFund: obj.hasClass('IsFund'), isControlsType: obj.hasClass('ControlsType'), fieldSetClasses: obj.parent().parent().attr('class') });
                    });

                    return data;
                };

                skyward.accountDimensionEEL.populateBoxes = function (eel, ajaxData, changed)
                {
                    changed = typeof changed !== 'undefined' ? changed : true;

                    var codeBox = eel.children(".accountDimensionEELCode").val(ajaxData.code);
                    if (codeBox.hasClass("ControlsType") && typeof controlsTypeChangedCallback === 'function')
                    {
                        controlsTypeChangedCallback(codeBox);
                    }

                    eel.children(".accountDimensionEELDescription").text(ajaxData.description);

                    if (changed)
                    {
                        eel.children(".accountDimensionEELValue").trigger('change');
                    }
                };

                //event hooks
                accountDimensionEELCode.change(function ()
                {
                    var sender = $(this);
                    //ensure the values clear out when the textbox is empty
                    if (sender.val().length == 0)
                    {
                        skyward.accountDimensionEEL.clear(sender.parent());
                    }
                });

                accountDimensionEELCode.keydown(keydown);
                accountDimensionEELCode.keyup(keyup);

                accountDimensionEELCodeButton.on("click", toggleCodePopup);
                updateBoxes();
            });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);

